import React from "react";
import TextField from "@mui/material/TextField";
import { withTranslation } from "react-i18next";

const ScopeModule = (props) => {
  return (
    <div>
      <div className="changeRequest_schedule">
        <h6 className="mb-0">{props.t("Current Scope")}</h6>
        <p className="mb-0 mt-1">
          {props.scope?.old === "null" ? "" : props.scope?.old}
        </p>
      </div>
      <div className="changeRequest_schedule mt-2">
        <h6 className="mb-0 mt-2">{props.t("Requested Scope")}</h6>
        <div className="row">
          <div className="col-md-12 changeRequest_datePicker mt-2">
            <TextField
              fullWidth
              multiline
              rows={3}
              id="outlined-multiline-static"
              label={props.t("Specify the change")}
              readOnly={true}
              name="scope"
              value={props.scope?.new}
              required
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation() (ScopeModule);
